export default function IconApplicationStep2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-04c67663-e025-423d-9b78-fcd4f225c7f5"
      data-name="Layer 2"
      viewBox="0 0 60 60"
    >
      <defs>
        <style>
          {
            ".uuid-ba9e97f4-d5fb-49b3-ae94-e143e0ac1600{fill:var(--color-primary);stroke-width:0}"
          }
        </style>
      </defs>
      <g id="uuid-6e1cb50a-fcb9-451b-b506-e35d222e3dad" data-name="Layer 1">
        <path
          d="M5.232 51.884 2.01 50.479l3.376-7.749a10.87 10.87 0 0 1 6.316-5.884l9.034-3.198.947-4.778 3.449.683-1.336 6.741-10.92 3.866a7.341 7.341 0 0 0-4.267 3.975l-3.376 7.749ZM50.514 51.883l-3.371-7.744a7.339 7.339 0 0 0-4.27-3.978L31.95 36.302l-1.336-6.75 3.448-.682.948 4.785 9.032 3.192a10.867 10.867 0 0 1 6.323 5.889l3.37 7.744-3.223 1.403Z"
          className="uuid-ba9e97f4-d5fb-49b3-ae94-e143e0ac1600"
        />
        <path
          d="M55.746 60H0V49.424h55.746V60Zm-52.23-3.516H52.23V52.94H3.516v3.545ZM39.626 15.152l-2.705-2.246a3.451 3.451 0 0 0 .794-2.2c0-3.965-3.226-7.19-7.191-7.19H18.03v7.19c0 .802.282 1.584.794 2.2l-2.705 2.246a6.976 6.976 0 0 1-1.604-4.445V0h16.008C36.427 0 41.23 4.803 41.23 10.707c0 1.62-.57 3.198-1.603 4.445Z"
          className="uuid-ba9e97f4-d5fb-49b3-ae94-e143e0ac1600"
        />
        <path
          d="M27.873 32.534c-5.686 0-10.318-4.845-10.373-10.822a5.239 5.239 0 0 1-3.254-4.84 5.237 5.237 0 0 1 4.902-5.22l.11-.003h7.265a3.207 3.207 0 0 0 3.203-3.203h3.516a3.207 3.207 0 0 0 3.203 3.203l.151.003a5.237 5.237 0 0 1 4.904 5.22 5.24 5.24 0 0 1-3.255 4.841c-.055 5.977-4.687 10.821-10.372 10.821Zm-8.552-17.37a1.713 1.713 0 0 0 .045 3.415l1.65.103v2.924c0 4.087 3.075 7.413 6.857 7.413s6.857-3.326 6.857-7.413v-2.923l1.65-.102a1.714 1.714 0 0 0 1.605-1.71c0-.888-.683-1.629-1.561-1.706a6.702 6.702 0 0 1-4.94-2.192 6.702 6.702 0 0 1-4.96 2.192h-7.202ZM26.63 39.348l5.608-5.612 2.486 2.485-5.608 5.612z"
          className="uuid-ba9e97f4-d5fb-49b3-ae94-e143e0ac1600"
        />
        <path
          d="m21.02 36.213 2.49-2.484 5.607 5.62-2.489 2.483zM12.803 44.981h3.516v6.201h-3.516zM39.426 44.981h3.516v6.201h-3.516zM51.182 17.637a8.747 8.747 0 0 1-3.168-.588l-5.251.189.188-5.253a8.746 8.746 0 0 1-.588-3.167C42.363 3.956 46.32 0 51.182 0S60 3.956 60 8.818s-3.956 8.819-8.818 8.819Zm-2.509-4.13.37.164a5.309 5.309 0 0 0 7.441-4.852c0-2.925-2.379-5.303-5.302-5.303s-5.303 2.378-5.303 5.302c0 .743.152 1.463.45 2.14l.164.369-.081 2.262 2.261-.082Z"
          className="uuid-ba9e97f4-d5fb-49b3-ae94-e143e0ac1600"
        />
        <path
          d="m21 47.903-5.72-10.307 3.073-1.707 3.77 6.794 4.7-3.502 2.1 2.82L21 47.903z"
          className="uuid-ba9e97f4-d5fb-49b3-ae94-e143e0ac1600"
        />
        <path
          d="m34.746 47.903-7.923-5.902 2.1-2.82 4.7 3.502 3.77-6.794 3.073 1.707-5.72 10.307z"
          className="uuid-ba9e97f4-d5fb-49b3-ae94-e143e0ac1600"
        />
      </g>
    </svg>
  );
}
